export function checkFairCategory(categoryID) {
  switch(categoryID) {
    case 0:
      return 'Chưa diễn ra';
      break;
    case 1:
      return 'Đang diễn ra';
      break;
    default:
      return 'Đã diễn ra'
  }
}


// WEBPACK FOOTER //
// ./actions/fairs.js